var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 4,
    viewBox: "0 0 98 4",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0306 0.380952C36.221 0.990476 35.0247 3.85551 33.0306 3.61905C18.5742 1.90479 6.11154 4 4.61603 4C3.12053 4 -4.35699 3.04762 3.61902 1.52381C11.595 0 29.0426 -0.380952 33.0306 0.380952Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9694 0.380952C61.779 0.990476 62.9753 3.85551 64.9694 3.61905C79.4258 1.90479 91.8885 4 93.384 4C94.8795 4 102.357 3.04762 94.381 1.52381C86.405 0 68.9574 -0.380952 64.9694 0.380952Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsC);
export default __webpack_public_path__ + "static/media/Brows C.83248401345bedd4741ea1b00809c649.svg";
export { ForwardRef as ReactComponent };